import React, { useCallback, useEffect, useState } from 'react';
import { UserTableProps} from '../../types/global';
import styled from 'styled-components';
import TrashIcon from '../icons/TrashIcon';
import CopyIcon from '../icons/CopyIcon';
import PenIcon from '../icons/PenIcon';
import Button from 'react-bootstrap/Button';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const UserImageContainer = styled.div`
    border: 1px solid #5f8d94;
    width: 2em;
    margin: auto;
    border-radius: 5px;
`

const UserImageComponent = styled.img`
    height: 100%;
    width: 100%;
`

const ActionButtonsContainer = styled.div`
    width: 100%;
    margin: auto;
    display: flex;
`

const UserTable: React.FC<UserTableProps> = ({users, deleteUserHandler, updateUserHandler}) => {
    const [copiedUserId, setCopiedUserId] = useState<string | null>(null);

    const copyUserCardUrl = useCallback((cardUrl: string, userId: string) => {
        return navigator.clipboard.writeText(cardUrl).then(() => {
            setCopiedUserId(userId);
            setTimeout(() => {
                setCopiedUserId(null);
            }, 2000);
          })
          .catch(err => {
            console.error("Failed to copy: ", err);
          });;
    }, []);

    return (
        <table className='table text-center'>
            <thead>
                <tr>
                    <th className="p-3">Prénom</th>
                    <th className="p-3">Nom</th>
                    <th className="p-3">Photo</th>
                    <th className="p-3">Poste</th>
                    <th className="p-3">Téléphone</th>
                    {/* <th className="p-3">Fiche contact</th> */}
                    <th className="p-3">Mail</th>
                    <th className="p-3">lien calendly</th>
                    <th className="p-3">Lien site</th>
                    <th className="p-3">Lien Linkedin</th>
                    <th className="p-3">Action</th>
                </tr>
            </thead>
            <tbody>
                {users.length > 0 ? users?.map((user, index) => (
                    <tr key={index}>
                        <td>{user.firstname}</td>
                        <td>{user.lastname}</td>
                        <td>
                            <UserImageContainer>
                                <UserImageComponent src={user.photo} />
                            </UserImageContainer>
                        </td>
                        <td>{user.poste}</td>
                        <td>{user.telephone}</td>
                        {/* <td>{user.fichecontact}</td> */}
                        <td>{user.email}</td>
                        <td>{user.lien1}</td>
                        <td>{user.lien2}</td>
                        <td>{user.lien3}</td>
                        <td>
                            <ActionButtonsContainer>
                                <OverlayTrigger 
                                        placement="top" 
                                        show={copiedUserId === user._id}
                                        overlay={<Tooltip id={`tooltip-top`}>{copiedUserId === user._id ? "Copied!" : "Copy"}</Tooltip>}
                                    >
                                    <Button variant="outline-light" onClick={() => user._id && user.cardurl && copyUserCardUrl?.(user.cardurl, user._id)}>
                                        <CopyIcon width={16} height={16} fill="black" />
                                    </Button>
                                </OverlayTrigger>
                                <Button variant="outline-light" onClick={() => user._id && updateUserHandler?.(user._id, user)}>
                                    <PenIcon width={16} height={16} fill="black" />
                                </Button>
                                <Button variant="outline-light" onClick={() => user._id && deleteUserHandler?.(user._id)}>
                                    <TrashIcon width={16} height={16} fill="red" />
                                </Button>
                            </ActionButtonsContainer>
                        </td>
                    </tr>
                )) : (
                    <div>La table est vide</div>
                )}
            </tbody>
        </table>
    )
}

export default UserTable;